export const THEMES = {
  METBUSLIGHT: 'METBUSLIGHT',
  METBUSDARK: 'METBUSDARK',
};
